import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchSubcategorias = async (url) => {
  try {
    const response = await axios.post(`${API_URL}/api/subcategorias`, {
        urlCat:url
    });

    return response.data;
  } catch (error) {
    console.log("Ha habido un error:", error);
    throw error;
  }
};